<template>
  <section class="c-extract-transactions has-text-centered">
    <base-reload
      v-if="transactions.loading"
      :isReload="false"
      :dark="true"
      label="Carregando últimas transações..."
    />

    <div v-else-if="transactions.pending">
      <BaseTransactionError />
    </div>

    <div v-else class="c-extract-transactions--space-bottom has-text-left">
      <div class="c-extract-transactions__wrapper">
        <BaseTransactionTabs
          :tabs="tabsContentFiltered"
          @tabClicked="setTabContent($event)"
        >
          <div v-if="tabIndex === 0">
            <div v-if="transactions && transactions.length">
              <div class="has-text-centered">
                <h1 class="is-size-6 has-text-weight-bold">
                  Acompanhe todas as suas transações
                </h1>
                <p class="has-text-grey">
                  <small v-if="walletUpdatedAt">
                    {{ walletUpdatedAt | updatedAt }}
                  </small>
                </p>
              </div>

              <BaseCardColor
                v-if="
                  this.walletSummary.wallet.settings &&
                  this.walletSummary.wallet.settings.shopping
                "
              >
                <div class="c-base-card-color-content columns is-vcentered">
                  <div class="column has-text-left">
                    <div class="box-cashback">
                      <h3
                        class="has-text-support is-size-6 has-text-weight-bold"
                      >
                        Você já recebeu de volta
                      </h3>
                      <span
                        class="has-text-support is-size-6 has-text-weight-bold"
                      >
                        + {{ walletSummary.total_cashback | currency }}
                      </span>
                    </div>
                    <p>Ganhe mais cashback comprando no Shopping Casar.com.</p>
                  </div>
                </div>
              </BaseCardColor>
              <div class="c-last-transactions__values has-text-left">
                <div v-for="(transaction, index) in transactions" :key="index">
                  <BaseTransaction :transaction="transaction" />
                </div>
              </div>

              <div class="has-text-centered">
                <button
                  v-if="meta && meta.current_page < meta.last_page"
                  @click="loadmore"
                  type="button"
                  class="button is-outlined is-black"
                >
                  Ver mais
                </button>
              </div>
              <div v-if="loadmoreError">
                <BaseTransactionError />
              </div>
            </div>
            <div class="has-text-centered" v-else>
              <BaseCardColor
                v-if="
                  this.walletSummary.wallet.settings &&
                  this.walletSummary.wallet.settings.shopping
                "
              >
                <div class="c-base-card-color-content columns is-vcentered">
                  <div class="column has-text-left">
                    <div class="box-cashback">
                      <h3
                        class="has-text-support is-size-6 has-text-weight-bold"
                      >
                        Você já recebeu de volta
                      </h3>
                      <span
                        class="has-text-support is-size-6 has-text-weight-bold"
                      >
                        + {{ walletSummary.total_cashback | currency }}
                      </span>
                    </div>
                    <p>Ganhe mais cashback comprando no Shopping Casar.com.</p>
                  </div>
                </div>
              </BaseCardColor>
              <p class="c-extract-transactions__wallet-empty">
                <b>Você ainda não efetuou nenhuma transação</b>
              </p>
            </div>
          </div>
          <div v-if="tabIndex === 1">
            <div v-if="creditTransactions && creditTransactions.length">
              <h2 class="is-size-6 has-text-weight-bold has-text-centered">
                Transações de créditos
              </h2>
              <div class="c-last-transactions__values has-text-left">
                <BaseTransaction
                  v-for="(transaction, index) in creditTransactions"
                  :key="index"
                  :transaction="transaction"
                />
              </div>
            </div>
            <div class="has-text-centered" v-else>
              <p class="c-extract-transactions__wallet-empty">
                <b>Você não possui nenhuma transação de crédito</b>
              </p>
            </div>
          </div>
          <div v-if="tabIndex === 2">
            <div v-if="debitTransactions && debitTransactions.length">
              <h2 class="is-size-6 has-text-weight-bold has-text-centered">
                Transações de débitos
              </h2>
              <div class="c-last-transactions__values has-text-left">
                <BaseTransaction
                  v-for="(transaction, index) in debitTransactions"
                  :key="index"
                  :transaction="transaction"
                />
              </div>
            </div>
            <div class="has-text-centered" v-else>
              <p class="c-extract-transactions__wallet-empty">
                <b>Você não possui nenhuma transação de débito</b>
              </p>
            </div>
          </div>
          <div v-if="tabIndex === 3">
            <div v-if="futureTransactions && futureTransactions.length">
              <h2 class="is-size-6 has-text-weight-bold has-text-centered">
                Créditos aguardando liberação
              </h2>
              <div class="c-last-transactions__values has-text-left">
                <BaseTransaction
                  v-for="(transaction, index) in futureTransactions"
                  :key="index"
                  :transaction="transaction"
                />
              </div>
            </div>
            <div class="has-text-centered" v-else>
              <p class="c-extract-transactions__wallet-empty">
                <b>
                  Você não possui nenhuma transação de crédito aguardando
                  liberação
                </b>
              </p>
            </div>
          </div>
        </BaseTransactionTabs>
      </div>
    </div>
  </section>
</template>

<script>
import BaseTransactionError from '@/components/Wallet/BaseTransactionError.vue'
import BaseTransactionTabs from '@/components/Wallet/BaseTransactionTabs.vue'
import BaseTransaction from '@/components/Wallet/BaseTransaction.vue'
import BaseCardColor from '@/components/Wallet/BaseCardColor.vue'
import WalletApi from '@/lib/api/Wallet'
import { format } from 'date-fns'

export default {
  components: {
    BaseTransaction,
    BaseTransactionError,
    BaseTransactionTabs,
    BaseCardColor,
  },

  data() {
    return {
      loadmoreError: false,
      tabIndex: 0,
      tabsContentForShoppingUser: [
        {
          title: 'Tudo',
        },
        {
          title: 'Recebido',
        },
        {
          title: 'Utilizado',
        },
        {
          title: 'Futuro',
        },
      ],
      tabsContentForCommonUser: [
        {
          title: 'Tudo',
        },
        {
          title: 'Recebido',
        },
        {
          title: 'Utilizado',
        },
      ],
    }
  },

  filters: {
    updatedAt(date) {
      return format(date, '[Atualizado em] DD/MM/YYYY [às] HH:mm')
    },
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
    transactions: {
      get() {
        return this.$store.state.wallet.transactions
      },
      set(payload) {
        this.$store.dispatch('setTransactions', payload)
      },
    },
    debitTransactions() {
      return this.$store.state.wallet.debitTransactions
    },
    creditTransactions() {
      return this.$store.state.wallet.creditTransactions
    },
    futureTransactions() {
      return this.$store.state.wallet.futureTransactions
    },
    walletUpdatedAt() {
      return this.$store.state.wallet.walletUpdatedAt
    },
    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },
    meta: {
      get() {
        return this.$store.state.wallet.transactionsMeta
      },
      set(payload) {
        this.$store.dispatch('setTransactionsMeta', payload)
      },
    },
    tabsContentFiltered() {
      if (
        this.walletSummary.wallet.settings &&
        this.walletSummary.wallet.settings.shopping
      ) {
        return this.tabsContentForShoppingUser
      }
      return this.tabsContentForCommonUser
    },
  },

  methods: {
    setTabContent(i) {
      this.tabIndex = i
    },
    loadmore() {
      if (this.meta.current_page < this.meta.last_page) {
        const walletApi = new WalletApi(this.logonToken)

        walletApi
          .getTransactions(this.meta.current_page + 1)
          .then((response) => {
            this.meta = response.data.meta
            this.transactions = this.transactions.concat(response.data.data)
          })
          .catch(() => (this.loadmoreError = true))
      }
    },
    scrollTo() {
      this.$scrollTo('.c-base-transaction-tabs', { offset: -200 })
    },
  },

  mounted() {
    this.scrollTo()
  },
}
</script>

<style lang="scss">
.c-extract-transactions {
  margin-top: 18px;
  padding-bottom: 20px;
  @media (min-width: $tablet) {
    height: calc(80vh - 60px);
  }

  &--space-bottom {
    padding-bottom: 100px;
  }

  &__wrapper {
    max-width: 660px;
    margin: 0 auto 18px;
  }

  &__wrapper-empty {
    margin: 50px auto 0px;
    @media (min-width: $tablet) {
      margin: 0px auto;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__wallet-image {
    @media (min-width: $tablet) {
      width: 200px;
      height: 165px;
    }
  }

  &__wallet-empty {
    padding: 10% 5%;
  }

  .c-base-card-color {
    width: calc(100% - 24px);
    margin: 1.5rem auto 0;

    .box-cashback {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }
  }

  .c-base-transaction-tabs {
    ul {
      display: flex;
    }

    li {
      flex: 1 1 0;
    }
  }
}

.new-menu {
  .c-extract-transactions {
    @media (min-width: $tablet) {
      min-height: calc(80vh - 60px);
      height: auto !important;
    }
  }
}
</style>
